/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Add Update user dialogs component
  Date: Sept 2020
**/

import React from 'react';
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
} from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { stringConstants } from '../../constants/stringConstants';
import { PopoverBtn } from '../../components';
import { globalPageTypeEntity } from '../../constants/applicationConstants';
import MuiPhoneNumber from 'material-ui-phone-number';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { PopupModal } from '../../submodule';

const DialogOrgsUser = (props) => {
  const {
    addedOrgsId,
    roleState,
    pageType,
    dialogType,
    updateUserFormData,
    onClose,
    open,
  } = props;

  //const [userData, setUserData] = React.useState({...initialUserData});

  const commonAction = useStoreActions((actions) => actions.common);
  const userAction = useStoreActions((actions) => actions.userList);
  const customizeAction = useStoreActions((actions) => actions.customize);
  const orgState = useStoreState((state) => state.organization);

  const [domainsList, setDomainsList] = React.useState([]);

  const initialUserData =
    dialogType === globalPageTypeEntity.edit
      ? {
          ...updateUserFormData,
          role:
            roleState && roleState[0] && roleState[0].PK ? roleState[0].PK : '',
        }
      : (
        (dialogType === globalPageTypeEntity.view) ? {
          ...updateUserFormData,
          role:
            roleState && roleState[0] && roleState[0].PK ? roleState[0].PK : '',
        } :      
        {
          username: '',
          firstname: '',
          lastname: '',
          current_status: 'ACTIVE',
          email: '',
          phone: '',
          role:
            roleState && roleState[0] && roleState[0].PK ? roleState[0].PK : '',
          //orgs: '',
          inactivedate: null,
          email_domain:
            orgState &&
            orgState.orgsData &&
            orgState.orgsData.config &&
            orgState.orgsData.config.allowed_domains &&
            orgState.orgsData.config.allowed_domains[0] &&
            orgState.orgsData.config.allowed_domains[0].domain
              ? orgState.orgsData.config.allowed_domains[0].domain
              : '',
          email_username: '',
        }
        );

  React.useEffect(() => {
    customizeAction.getConfigData();
  }, []);

  /*
  React.useEffect(() => {  
    if (roleState && roleState[0] && roleState[0].PK) {
      setUserData({...userData, role: roleState[0].PK});
    }
  }, [roleState]); */

  React.useEffect(() => {
    //console.log('orgState=', orgState)

    if (
      orgState.orgsData &&
      orgState.orgsData.config &&
      orgState.orgsData.config.allowed_domains
    ) {
      setDomainsList(orgState.orgsData.config.allowed_domains);

      if (
        orgState.orgsData.config.allowed_domains.length > 0 &&
        orgState.orgsData.config.allowed_domains[0] &&
        orgState.orgsData.config.allowed_domains[0].domain
      ) {
        //initialUserData.email_domain = orgState.orgsData.config.allowed_domains[0].domain;
        //initialUserData = {...initialUserData, email_domain: orgState.orgsData.config.allowed_domains[0].domain}
        //setUserData({...userData, email_domain: orgState.orgsData.config.allowed_domains[0].domain});
      }
    }
  }, [orgState]);

  //Validation Schema of the formik form fields
  const schema = Yup.object().shape({
    username: Yup.string()
      .required(stringConstants.requiredValidationMsg)
      .min(4, stringConstants.userCharLimitValidMsg)
      .max(70, stringConstants.userMaxCharLimitValidMsg)
      .matches(
        /^[A-Za-z0-9]+$/,
        `User name ${stringConstants.specialCharValidationMsg}`,
      ),
    firstname: Yup.string()
      .required(stringConstants.requiredValidationMsg)
      .max(30, `First Name ${stringConstants.thirtyCharLimitValidMsg}`),
    lastname: Yup.string()
      .required(stringConstants.requiredValidationMsg)
      .max(30, `Last Name ${stringConstants.thirtyCharLimitValidMsg}`),
    email_username: Yup.string().required(
      stringConstants.requiredValidationMsg,
    ).matches(
      /^[A-Za-z0-9._-]+$/,
      `Email ${stringConstants.specialCharValidationMsg}`,
    ),
    phone: Yup.string()
      .nullable()
      .matches(
        /^\+[1]((\s)[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4})?$/g, // NOSONAR
        stringConstants.phoneValidationMsg,
      ),
  });

  // Form Reset Handler
  const handleReset = (resetForm) => {
    resetForm();
    onClose();
  };

  // On Form Submission Handler
  const onFormSubmit = async (values, { setErrors }) => {
    const { PK, ...temp } = values;

    temp.email =
      temp.email_username.trim().toLowerCase() + '@' + temp.email_domain;

    if (PK) {
      userAction
        .updateUser({
          ...temp,
          orgs_id: addedOrgsId,
          PK,
        })
        .then(function (response) {
          userAction.getUserList(addedOrgsId);
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.updateMsg,
          });
          onClose();
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            let outputErrors = {};
            const errorlist = error.response.data.error;
            for (let item in errorlist) {
              if(errorlist && errorlist[item] && Object.keys(errorlist[item]) && Object.keys(errorlist[item])[0] === 'email') {
                outputErrors['email_username'] =
                  errorlist[item][Object.keys(errorlist[item])];
              } else {
                outputErrors[Object.keys(errorlist[item])] =
                  errorlist[item][Object.keys(errorlist[item])];
              }
            }
            setErrors(outputErrors);
          }
        });
    } else {
      await userAction
        .addUser({
          ...temp,
          orgs_id: addedOrgsId,
        })
        .then(function (response) {
          userAction.getUserList(addedOrgsId);
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.addedRecordMsg,
          });
          onClose();
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            let outputErrors = {};
            const errorlist = error.response.data.error;
            for (let item in errorlist) {
              if(errorlist && errorlist[item] && Object.keys(errorlist[item]) && Object.keys(errorlist[item])[0] === 'email') {
                outputErrors['email_username'] =
                  errorlist[item][Object.keys(errorlist[item])];
              } else {
                outputErrors[Object.keys(errorlist[item])] =
                  errorlist[item][Object.keys(errorlist[item])];
              }
            }
            setErrors(outputErrors);
          }
        });
    }
  };

  return (
    <PopupModal open={open}>
      <Formik
        initialValues={initialUserData}
        onSubmit={onFormSubmit}
        validationSchema={schema}
        enableReinitialize={true}
      >
        {(formikProps) => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            //handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            dirty,
            isValid,
          } = formikProps;
          console.log(formikProps);
          return (
            <form onSubmit={handleSubmit} noValidate>
              <Grid
                container
                style={{ padding: '25px 50px', margin: '0 -16px' }}
                spacing={2}
                alignItems="flex-start"
              >
                <Grid item sm={12}>
                  <Typography variant="h4">{
                    (dialogType === globalPageTypeEntity.edit) ? 'Edit User' : (
                      dialogType === globalPageTypeEntity.view ? 'View User' : "Add User"
                    )
                  } </Typography>
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    disabled={
                      (pageType === globalPageTypeEntity.edit &&
                      updateUserFormData.username) || (dialogType === globalPageTypeEntity.view)
                    }
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    name="username"
                    label="User Name"
                    variant="outlined"
                    value={values.username}
                    onChange={(e, v) => {
                      setFieldValue('username', e.target.value, true);
                    }}
                    onBlur={handleBlur}
                    error={errors.username && touched.username}
                    helperText={
                      errors.username && touched.username && errors.username
                    }
                  ></TextField>
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="firstname"
                    name="firstname"
                    label="First Name"
                    variant="outlined"
                    disabled={dialogType === globalPageTypeEntity.view}
                    value={values.firstname}
                    onChange={(e, v) => {
                      setFieldValue('firstname', e.target.value, true);
                    }}
                    onBlur={handleBlur}
                    error={errors.firstname && touched.firstname}
                    helperText={
                      errors.firstname && touched.firstname && errors.firstname
                    }
                  ></TextField>
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="lastname"
                    name="lastname"
                    label="Last Name"
                    variant="outlined"
                    value={values.lastname}
                    disabled={dialogType === globalPageTypeEntity.view}
                    onChange={(e, v) => {
                      setFieldValue('lastname', e.target.value, true);
                    }}
                    onBlur={handleBlur}
                    error={errors.lastname && touched.lastname}
                    helperText={
                      errors.lastname && touched.lastname && errors.lastname
                    }
                  ></TextField>
                </Grid>
                <Grid item sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        labelId="email_username-label"
                        id="email_username"
                        variant="outlined"
                        placeholder="email"
                        fullWidth
                        InputProps={{
                          endAdornment: '@',
                        }}
                        margin="normal"
                        required
                        name="email_username"
                        label="Email"
                        disabled={dialogType === globalPageTypeEntity.view}
                        value={values.email_username}
                        //onChange={handleChange}
                        onChange={(e, v) => {
                          setFieldValue('email_username', e.target.value, true);
                        }}
                        onBlur={handleBlur}
                        error={errors.email_username && touched.email_username}
                        helperText={
                          errors.email_username &&
                          touched.email_username &&
                          errors.email_username
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        labelId="email_domain-label"
                        id="email_domain"
                        placeholder="Domain"
                        name="email_domain"
                        fullWidth
                        value={values.email_domain}
                        //onChange={handleChange}
                        onChange={(e, v) => {
                          setFieldValue('email_domain', e.target.value, true);
                        }}
                        label="Domain"
                        variant="outlined"
                        disableElevation
                        disabled={dialogType === globalPageTypeEntity.view}
                        style={{
                          marginTop: '8px',
                          marginLeft: '10px',
                          textDecoration:
                            domainsList.filter(
                              (i) =>
                                i.domain == values.email_domain &&
                                i.active === false,
                            ).length > 0
                              ? 'line-through'
                              : 'none',
                        }}
                      >
                        {domainsList && domainsList.length > 0
                          ? domainsList
                              .filter((i) => {
                                if (values.PK && values.PK.length > 0) {
                                  //edit
                                  return true;
                                } else {
                                  //add
                                  return i.active;
                                }
                              })
                              .map((option, index) => {
                                if (option.domain) {
                                  return (
                                    <MenuItem
                                      key={`domain-${index}`}
                                      value={option.domain}
                                      style={{
                                        textDecoration: !option.active
                                          ? 'line-through'
                                          : 'none',
                                      }}
                                    >
                                      {option.domain}
                                    </MenuItem>
                                  );
                                }
                              })
                          : ''}
                      </Select>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={5} style={{ marginTop: 10 }}>
                  <MuiPhoneNumber
                    countryCodeEditable={false}
                    id="phone"
                    name="phone"
                    label="Phone"
                    variant="outlined"
                    value={values.phone}
                    fullWidth
                    defaultCountry={'us'}
                    onlyCountries={['us']}
                    disabled={dialogType === globalPageTypeEntity.view}
                    onChange={(e, v) => {
                      setFieldValue('phone', e, true);
                    }}
                    error={errors.phone && touched.phone}
                    helperText={errors.phone && touched.phone && errors.phone}
                    onBlur={handleBlur}
                    className={
                      touched.phone && errors.phone ? 'has-error' : null
                    }
                  />
                </Grid>
                <Grid item md={1} style={{ marginTop:20}}>
                <PopoverBtn
                        icon="help-outline"
                        description={
                          <p>
                            {' '}
                            Valid Phone Numbers:
                            <br />
                            +1 (234) 567-8900
                          </p>
                        }
                      ></PopoverBtn>
                </Grid>
                <Grid sm={12} item>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item>
                      <Button
                        onClick={handleReset.bind(null, resetForm)}
                        variant="contained"
                        color="secondary"
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={!isValid || !dirty || (dialogType === globalPageTypeEntity.view)}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          );
        }}
      </Formik>
    </PopupModal>
  );
};
export default DialogOrgsUser;
